import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M303.94 179.34c0-46.48-37.68-84.15-84.15-84.15s-84.15 37.68-84.15 84.15c0 4.43.34 8.78 1 13.02-4.24-.66-8.59-1-13.02-1-46.48 0-84.15 37.68-84.15 84.15s37.68 84.15 84.15 84.15c42.4 0 77.47-31.35 83.3-72.13H111.6",
  style: {"fill":"none","stroke":"#16b0db","stroke-miterlimit":"10","stroke-width":"34.41px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M491.06 308.42V274l-29.08-4.31a95.8 95.8 0 0 0-12.34-29.78l17.52-23.61-24.34-24.34-23.61 17.52a95.8 95.8 0 0 0-29.78-12.34l-4.31-29.08H350.7l-4.31 29.08a95.8 95.8 0 0 0-29.78 12.34L293 191.96l-24.34 24.34 17.52 23.61a95.8 95.8 0 0 0-12.34 29.78L244.76 274v34.42l29.08 4.31a95.8 95.8 0 0 0 12.34 29.78l-17.52 23.61L293 390.46l23.61-17.52c9.03 5.68 19.06 9.9 29.78 12.34l4.31 29.08h34.42l4.31-29.08a95.8 95.8 0 0 0 29.78-12.34l23.61 17.52 24.34-24.34-17.52-23.61c5.68-9.03 9.9-19.06 12.34-29.78zm-123.14 52.97c-38.76 0-70.18-31.42-70.18-70.18s31.42-70.18 70.18-70.18 70.18 31.42 70.18 70.18-31.42 70.18-70.18 70.18",
  style: {"fill":"#b6489b","stroke-width":"0"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }